import { MicroappActionTypes } from './action-types';
export const updateMicroappState = (microapp, data) => dispatch => {
  return dispatch({
    type: MicroappActionTypes.UpdateMicroapp,
    microapp,
    data
  });
};